import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { MainLayout } from '@/app/navigation'
import { banqueTabs } from './config/tabs.config'
import { ReportsTab } from './tabs/reports'
import { ReportDetail } from './tabs/reports/components/ReportDetail'
import { SettingsTab } from './tabs/settings/SettingsTab'

export const BanqueLayout: React.FC = () => {
  return (
    <MainLayout tabs={banqueTabs}>
      <Routes>
        {/* Tab routes */}
        <Route path="reports" element={<ReportsTab />} />
        <Route path="settings" element={<SettingsTab />} />

        {/* Detail view route */}
        <Route path="report/:reportId" element={<ReportDetail />} />

        {/* Default route - redirect to reports */}
        <Route path="/" element={<Navigate to="reports" replace />} />
        <Route index element={<Navigate to="reports" replace />} />
      </Routes>
    </MainLayout>
  )
}